import { ChangeDetectionStrategy, Component, HostListener, inject, signal } from '@angular/core';
import { I18n, NgtGlobalThemeService } from '@corporate/ng-tebis-base-components';
import { LoginComponent } from './07_feature/login/login.component';
import { AuthService } from './01_core/auth/auth.service';
import { FlatLayoutComponent } from './05_layout/flat-layout/flat-layout.component';
import { TabService } from './05_layout/flat-layout/flat-tabs/tab.service';
import { TestingService } from './testing.service';
import { MainLayoutComponent } from './05_layout/main-layout/main-layout.component';
import { AssistantService } from './04_service/assistant/assistant.service';

@Component({
  selector: 'tps-root',
  standalone: true,
  imports: [
    FlatLayoutComponent,
    MainLayoutComponent,
    LoginComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'SME Process Solution';
  i18n = inject<I18n>(I18n);
  tabService = inject(TabService);
  authService = inject(AuthService);
  globalThemeService = inject(NgtGlobalThemeService);
  assistantService = inject(AssistantService);

  testing = inject(TestingService);

  count = signal(0);

  constructor() {
    this.i18n.addNamespace('common');
    this.globalThemeService.setDarkMode();
  }

  @HostListener('window:dragover', ['$event'])
  onWindowDragOver(event: DragEvent) {
    event.preventDefault();
  }

  @HostListener('window:drop', ['$event'])
  async onWindowDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files?.length) {
      await this.assistantService.addFilesAsContext(files);
    }
  }
}
